<footer>
    <div
        id="footer-contents"
        [innerHTML]="footer | unsafeHtml"
    >
    </div>
</footer>
